import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { FikoYTKokBilesenComponent } from '../../../../kok-bilesen/kok-bilesen.component';


@Component({
  selector: 'fikoyt-dalga',
  standalone: true,
  imports: [CommonModule,],
  templateUrl: "./fikoyt-dalga.component.html",
  // styleUrl: "./fikoyt-uygulama-baslik.component.scss",

})
export class FikoYTDalgaComponent extends FikoYTKokBilesenComponent {
  @Input() color: string = 'rgb(4, 0, 255)'; // Ripple rengi
  @Input() duration: number = 1000; // Animasyon süresi (ms)
  @Input() delay: number = 1000; // Gecikme (ms)
  @Input() repeat: boolean = true; // Tekrar durumu
  @Input() waveCount: number = 2; // Dalga sayısı
  @Input() shape: 'circle' | 'rectangle' = 'circle'; // Şekil tipi
  @Input() borderRadius: string = '24px'; // Dikdörtgen için radius

  waves: number[] = []; // Dalga dizisi

  constructor(private el: ElementRef, private renderer: Renderer2) {
    super();

  }

  ngOnInit(): void {
    this.generateWaves();
  }

  override ngAfterViewInit(): void {

  }

  generateWaves(): void {
    this.waves = Array(this.waveCount).fill(0).map((_, i) => i); // Dalga indexleri
  }

  // triggerRipple(x: number = 0, y: number = 0) {
  //   const hostElement = this.el.nativeElement;

  //   // Ripple divini oluştur
  //   const ripple = this.renderer.createElement('div');
  //   this.renderer.addClass(ripple, 'ripple');
  //   this.renderer.setStyle(ripple, 'width', `${hostElement.offsetWidth * 2}px`);
  //   this.renderer.setStyle(
  //     ripple,
  //     'height',
  //     `${hostElement.offsetHeight * 2}px`
  //   );
  //   this.renderer.setStyle(ripple, 'animation-duration', `${this.duration}ms`);

  //   // Ripple'in başlangıç pozisyonunu ayarla
  //   this.renderer.setStyle(ripple, 'left', `${x}px`);
  //   this.renderer.setStyle(ripple, 'top', `${y}px`);

  //   // Ripple'i DOM'a ekle
  //   this.renderer.appendChild(hostElement, ripple);

  //   // Ripple'in DOM'dan kaldırılması
  //   setTimeout(() => {
  //     this.renderer.removeChild(hostElement, ripple);
  //   }, this.duration);
  // }
}
